import Page from '../_layout/Page';
import React, { useEffect, useMemo, useState } from 'react';
import ReportYear from '../ProjectReportTabs/ReportYear';
import BackBtn from '../UI/BackBtn';
import ForbiddenAccess from '../ForrbiddenAccessComponent/ForbiddenAccess';
import { useParams } from 'react-router-dom';
import { getProjectPerms, hasPermsOnIndexesOrReceipts, isAdminReadRestricted, isCommandManagmentOrProjOffice } from '../../services/rolesSvc';
import useUserContext from '../../hooks/useUserContext';
import UnifiedProjTable from "../../pages/project/PortfolioProject/WidgetsPages/UnifiedProjTable";
import useNavProject from "../../hooks/useNavProject";
import useAPI from "../../hooks/useAPI";
import { BaseRequests } from "../../requests/BaseRequests";
import MilestonesTable from "./Widgets/Milestones/MilestonesTable";
import Receipts from "../table/Receipts";
import ReceiptsAddContract from "../ReceiptsAddContract";
import ReceiptEdit from "../ReceiptEdit";
import EditFactForm from "./Widgets/Milestones/EditFactForm";

export default function ProjectReportWidgets(){
  const { type, stratId, projId, policyId, reportYear } = useParams();
  const userCtx = useUserContext()
  const [project, setProject] = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false)
  const navProject = useNavProject()
  const api = useAPI()
  // useProjectForNav(api, navProject);
  useEffect(async () => {
    const respProject = await api.get(`/structure/projs/${projId}`);
    setIsLoaded(true)
    if (!respProject || respProject.error) return;
    setPermissions(getProjectPerms(userCtx, respProject.id, respProject.strategy?.id, respProject.portfolio?.id));
    setProject(respProject);
    BaseRequests.getNavigationLinks(respProject, navProject)
  }, []);

  const content = useMemo(() => [
    !!project && {
      type: `year`,
      content: <ReportYear
        stratId={stratId}
        title={project.name}
        projectId={project.id}
        permissions={{
          canRead: permissions.canRead,
          canEdit: permissions.canWrite,
        }}
        role={{
          strategy: permissions.strategyRole,
          project: permissions.projectRole,
        }}
        reportYear={reportYear ? parseInt(reportYear) : 2022}
        project={project}
      />,
      show: () => permissions.canRead || permissions.canWrite,
    },
    { type: 'unified', content: <UnifiedProjTable />, show: () => hasPermsOnIndexesOrReceipts(userCtx, { stratId, projId }) },
    { type: 'milestones', content: <MilestonesTable /> },
    { type: 'milestone', content: <EditFactForm /> },
    { 
      type: 'receipts', 
      content: 
        <Receipts 
          stratId={stratId} 
          projId={projId} 
          tableLeftValues={[140, 316]}
          type={'projectReceipts'}
          totalIndex={2}
        />, 
      show: () => hasPermsOnIndexesOrReceipts(userCtx, {stratId, projId})
    },
    { type: 'nreceipt', content: <ReceiptsAddContract stratId={stratId} projId={projId} />, show: () => isCommandManagmentOrProjOffice(userCtx, stratId, projId) },
    { type: 'receipt', content: <ReceiptEdit stratId={stratId} projId={projId} />, show: () => isCommandManagmentOrProjOffice(userCtx, stratId, projId)},
  ], [project, permissions, userCtx]);

  return (
    <Page styleSection={{ backgroundColor: !['unified, milestones'].includes(type) ? 'fff' : '#F5F5FF'  }}>
      <BackBtn />
      {isLoaded &&
        <>
          {content.filter((x) => x.type === type)[0]?.header
            && <div className="project-title-wrapper" style={{ paddingBottom: '0', color: '#0C0065' }}>
              <h2>{content.filter((x) => x.type === type)[0]?.header}</h2>
            </div>}
          {content.filter((x) => x.type === type && (!x.show || x.show(userCtx.perms)))[0]?.content || <ForbiddenAccess />}
        </>}
    </Page>
  )
}
